export { getLayoutContextValue } from './src/getLayoutContextValue';
export * from './src/index';

/** @todo FC-739 Удалить этот экспорт в следующей мажорной версии */
export * from './index-deprecated';
